module.exports = __webpack_public_path__ + "img/green-hairy-grass-04.a7f125b2.png";